import { render, staticRenderFns } from "./withdrawalAudit.vue?vue&type=template&id=72fab4fa&scoped=true&"
import script from "./withdrawalAudit.vue?vue&type=script&lang=js&"
export * from "./withdrawalAudit.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalAudit.vue?vue&type=style&index=0&id=72fab4fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fab4fa",
  null
  
)

export default component.exports